import { getDaysDifferenceBetweenDates } from '../../utilities/dateHelper';
import { applicationStatus } from './constant';

export const getformattedCourseApplicationForCSV = ({ list }) => {
  try {
    return list.map((data, index) => {
      const isPending = data.status === applicationStatus.PENDING;

      const pendingDays = getDaysDifferenceBetweenDates({
        date1: new Date(),
        date2: data?.registrationTime
      });

      const passChecks = ({ field }) => {
        return field ? field.toString() : '-';
      };

      return {
        index: passChecks({ field: index + 1 }),
        fullName: passChecks({
          field: data?.firstName + ' ' + data?.lastName
        }),
        country: passChecks({ field: data?.country }),
        email: passChecks({ field: data?.email }),
        type: passChecks({ field: data?.type }),
        status: passChecks({ field: data?.status }),
        registrationTime: passChecks({ field: data?.registrationTime }),
        pendingDays: isPending ? `${pendingDays} days` : '-',
        registrationTz: passChecks({ field: data?.registrationTz }),
        statusUpdatedAt: passChecks({ field: data?.statusUpdatedAt }),
        reviewerNotes: passChecks({ field: data?.reviewerNotes }),
        phoneNumber: passChecks({ field: data?.phoneNumber }),
        linkedInUrl: passChecks({ field: data?.linkedInUrl }),
        motivation: passChecks({ field: data?.motivation }),
        occupation: passChecks({ field: data?.occupation }),
        socialMediaLink: passChecks({ field: data?.socialMediaLink }),
        callTime: passChecks({ field: data?.callTime }),
        acceptTime: passChecks({ field: data?.acceptTime }),
        acceptPrice: passChecks({ field: data?.acceptPrice }),
        acceptTnC: passChecks({ field: data?.acceptTnC })
      };
    });
  } catch (e) {
    throw new Error(e);
  }
};

export const isInternalEmail = ({ email }) => {
  try {
    const emailDomain = email.split('@')[1];
    const internalDomains = [
      'nasacademy.com',
      'nasdaily.com',
      'nas.io',
      'thenasacademy.com'
    ];

    return internalDomains.includes(emailDomain);
  } catch (e) {
    console.error(e);
    return false;
  }
};
